export default class Facility {
  id = null;
  name = "";
  objectNumber = "";
  stairway = "";
  building = null;
  manager = null;
  documentation = null;
  displayId = null;
  qrcode = null;
  publicProcessAccess = true;
  type = null;
  fullService = false;
  hasPOA = false;

  constructor() {
  }
}
